import md5 from "blueimp-md5"
import request from './request'


// 获取openid
export function getOpenId(code, callback) {
  // code换取openid
  let openid = ''
  request({ url: 'userOauth', data: { code: code } }).then(userRes => {
    console.log('获取用户openid返回', userRes.data.openid)

    openid = userRes.data ? userRes.data.openid : ''
    console.log('获取openid成功', openid)
    if (openid) {
      window.localStorage.setItem('openid', openid)
      callback && callback(openid)
    }
  })
}

// 微信静默授权获取code链接
export async function getCodeUrl() {
  var local = window.location.href.split('?') // 获取页面url
  console.log(local)
  var res = await request({ url: 'userOauth', data: { url: local[0] } })
  if (res) {
    console.log('请求回调链接得到res', res.data.url)
    let url = res.data.url
    if(local[1]){  //如果有参数,就替换state中的字段
      let par = local[1].replace(/&/g,"/")
      let statePar = decodeURIComponent(url).match(new RegExp("(^|&)"+ "state" +"=([^&]*)(&|$)"))[2]
      statePar= statePar.replace("#wechat_redirect","")
      url = url.replace(statePar,par)

      // let reg = /(?<=state=).+(?=#)/
      // url = url.replace(reg,par)

    }
    window.location.href = url
  }

  // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd92293402f73f76f&redirect_uri=http://test-doutui.mambike.com/index&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
}


// 解析url参数并获取code
export function getUrlCode(callback) { // name为要获取的参数名
  var url = window.location.href
  console.log(url)
  // var url = 'http://test-doutui.mambike.com/index?code=001IR8000jAdaK1NJX200hM63N3IR80z&state=STATE'
  var obj = {}
  var num = url.indexOf('?')
  if (num != -1) {
    var str = url.slice(num + 1)
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      obj[strs[i].split('=')[0]] = (strs[i].split('=')[1])
    }
  }
  console.log(obj)
  var code = obj.code ? obj.code : ''
  if (code) {
    // callback(code)
    getOpenId(code,callback)
  } else {
    getCodeUrl()
  }
}

export function getChannelRec(openid,pathId){ //落地页埋点
  //判断落地页是否是第一次进入
  let isTagFirst = window.sessionStorage.getItem("isTagFirst")
  if (isTagFirst) return
  request({
   url: "channelRec",
   data: { openid, channel_id:pathId,type:"10" },
 },1).then((res) => {
   console.log("落地页埋点成功");
   window.sessionStorage.setItem("isTagFirst",true)
  }).catch()
}

// export function getUrlParam(name) {  //获取url上的参数
//   var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
//   var r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
//  if(r!=null)return  unescape(r[2]); return null;
// }
export function _getUrlParam(val,name) {
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  let _val = val.split("?")[1]
  if (!_val) {
    return null
  }
  var r = _val.match(reg);//search,查询？后面的参数，并匹配正则
  // console.log("_val",_val);
 if(r!=null)return  unescape(r[2]); return null;
}
export function _getStatePar(val,name){
 let reg = new RegExp("(^|/)"+ name +"=([^/]*)(/|$)")
 let r = val.match(reg)
  console.log("val",val);
 if(r!=null)return  unescape(r[2]); return null;
}
export function _getState(val){
  // let reg =  /(?<=state=).+(?=#)/
  // let r = decodeURIComponent(val).match(reg)
  // console.log("stateR",r);
  // if(r!=null)return  unescape(r[0]); return null;
  var reg = new RegExp("(^|&)"+ "state" +"=([^&]*)(&|$)");
  let r = decodeURIComponent(val).match(reg)
  if(r!=null)return  unescape(r[2].substr(0,r[2].length-2)); return null;
}